import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getShopsAction } from '../../api/action/shop.action';
import { QUERY_KEY } from '../../api/types/query.type';
import { createTabs } from '../../components/UIcomponents/Tabs/helpers.tabs';
import { SettingsProvider, useSettings } from '../../context/Settings';
import { theme } from './ShopsTheme';
var AlertComponent = lazy(function () { return import('../../components/UIcomponents/AlertComponent/AlertComponent'); });
var TabPanel = lazy(function () { return import('../../components/UIcomponents/TabPanel'); });
var ShopTabs = lazy(function () { return import('../../components/UIcomponents/Tabs'); });
var Loader = lazy(function () { return import('../../components/UIcomponents/Loader'); });
var ShopForm = lazy(function () { return import('../../components/Forms/ShopForm'); });
var SettingsProgress = lazy(function () { return import('../../modules/SettingsProgress'); });
var Webhooks = lazy(function () { return import('../Webhooks'); });
var ExtraSettings = lazy(function () { return import('../ExtraSettings'); });
var INITIAL_TAB_INDEX = 0;
var ShopTabContent = function (_a) {
    var shopId = _a.shopId, shopName = _a.shopName, shopDomain = _a.shopDomain, onDeleteSuccess = _a.onDeleteSuccess;
    var shopSettings = useSettings().shopSettings;
    return (_jsxs(Box, { sx: theme.contentContainer, children: [_jsx(SettingsProgress, { shopId: shopId }), _jsx(ShopForm, { shopId: shopId, name: shopName, domain: shopDomain, onDeleteSuccess: onDeleteSuccess }), shopDomain && _jsx(Webhooks, { shopId: shopId }), shopSettings.isWebhookAdded && _jsx(ExtraSettings, { shopId: shopId })] }));
};
var Shops = function () {
    var _a = useState(INITIAL_TAB_INDEX), value = _a[0], setValue = _a[1];
    var t = useTranslation('settings').t;
    var _b = useQuery({
        queryKey: [QUERY_KEY.GET_SHOPS],
        queryFn: getShopsAction,
    }), shops = _b.data, isLoadingShops = _b.isLoading, error = _b.error;
    var handleDeleteSuccess = function () {
        setValue(INITIAL_TAB_INDEX);
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var tabsContent = (shops === null || shops === void 0 ? void 0 : shops.data) ? createTabs(shops.data) : createTabs([]);
    var isLoading = isLoadingShops;
    if (isLoading) {
        return (_jsx(Box, { sx: theme.container, children: _jsx(Loader, { type: "form", fieldsCount: 2 }) }));
    }
    if (error) {
        return (_jsx(Box, { sx: theme.container, children: _jsx(AlertComponent, { type: "error", message: t('shop.error.getShops') }) }));
    }
    return (_jsxs(Box, { sx: theme.container, children: [_jsx(ShopTabs, { value: value, onChange: handleChange, shops: shops === null || shops === void 0 ? void 0 : shops.data }), tabsContent.map(function (tab, index) { return (_jsx(TabPanel, { value: value, index: index, children: tab.shop ? (_jsx(SettingsProvider, { shopId: tab.shop._id, children: _jsx(ShopTabContent, { shopId: tab.shop._id, shopName: tab.shop.name, shopDomain: tab.shop.domain, onDeleteSuccess: handleDeleteSuccess }) })) : (_jsx(SettingsProvider, { children: _jsxs(Box, { sx: theme.contentContainer, children: [_jsx(SettingsProgress, {}), _jsx(ShopForm, { shopId: "", name: "", domain: "", onDeleteSuccess: handleDeleteSuccess })] }) })) }, "Tab settings ".concat(index))); })] }));
};
export default Shops;
